/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";


import DOCUMENT_ICON from "@Icons/document.png";


import DOCUMENT_INTERFACE from "@Services/Application/Interfaces/Documents/Document";


import generateDocumentFromBinary from "@Utilities/Documents/FromBinary";


type TransportDocumentProps = {
    DOCUMENT: DOCUMENT_INTERFACE;
};


export const TransportDocumentComponent: React.FC<TransportDocumentProps> = ({
    DOCUMENT
}): JSX.Element | null => {


    if (!DOCUMENT) return null;

    const DOCUMENT_DOWNLOAD_HANDLER = () => {
        generateDocumentFromBinary(DOCUMENT.DocData || "");
    };

    return (
        <Col xs={12} className={"finished-transport-document finished-transport-document-component"}>
            <Row className={"finished-transport-document-content"}  onClick={() => DOCUMENT.DocData ? DOCUMENT_DOWNLOAD_HANDLER() : null}>

                <Col xs={10} className={"transport-document-name"}>
                    <span>{DOCUMENT.DocName}</span>
                </Col>

                <Col xs={2} className={"transport-document-icon"}>
                    <img src={DOCUMENT_ICON} alt={DOCUMENT.DocTypeName} />
                </Col>

            </Row>
        </Col>
    );

};


export default TransportDocumentComponent;
